import * as React from 'react';
import { BUYERS_GUIDE_IMG, BUYERS_GUIDE_LINK, CX_LIBRARY_IMG, CX_LIBRARY_LINK, DOWNLOAD_NOW_ICON, LEARN_MORE_ICON, SUPPORT_LEADERS_CHALLENGES_IMG, SUPPORT_LEADERS_CHALLENGES_LINK, TaAnswerData } from '../../ta-shared';
import { TaResultDetailsSection } from './ta-result-details-section/comp';

type TaResultDetailsProps = {
	userAnswerssData: TaAnswerData[];
	fullName: string;
};

export const TaResultDetails = ({userAnswerssData, fullName}: TaResultDetailsProps) => {

	const filterAnswersData = (data: TaAnswerData[], filter: string): TaAnswerData[] => {
		return data.filter(
			(answer: TaAnswerData) => answer.subject.toUpperCase() === filter
		);
	};

	const totalScore = userAnswerssData.reduce((acc: number, value: any) => acc + value.score, 0);

	const renderScoreTitle = (score: number) => {
		if (score > 85) {
			return 'your support tech stack is onwards and upwards from here!';
		} else if (score > 60) {
			return 'your support tech stack is okay.';
		} else {
			return 'it’s time to make some much-needed improvements.';
		}
	};

	const renderScoreSubtitle = (score: number) => {
		if (score > 85) {
			return 'Now, let\'s take it to greater heights! Here are some tips and resources to help maximize your stack:';
		} else if (score > 60) {
			return 'Now, let\'s see how we can bump up that score with practical tips and resources to help enhance and maximize your stack:';
		} else {
			return 'We\'ve set the foundation with practical tips and resources that\'ll go a long way toward helping you enhance your stack:';
		}
	};

	return (
		<div className='ta-result-details-container'>
			<div className='ta-result-details-header'>
				<div className='ta-result-details-header_title' style={(totalScore > 85 || totalScore < 60) ? {fontSize: '40px', lineHeight: '52px'} : {}}>
					{fullName || 'Hey'},{' '}
					{renderScoreTitle(totalScore)}
				</div>
				<div className='ta-result-details-header_subtitle'>
					{renderScoreSubtitle(totalScore)}
				</div>
			</div>

			<TaResultDetailsSection
				filteredAnswerssData={filterAnswersData(userAnswerssData, 'TECH STACK')}
			/>
			<TaResultDetailsSection
				filteredAnswerssData={filterAnswersData(userAnswerssData, 'PRODUCTIVITY')}
			/>
			<TaResultDetailsSection
				filteredAnswerssData={filterAnswersData(userAnswerssData, 'SCALABILITY')}
			/>
			<TaResultDetailsSection
				filteredAnswerssData={filterAnswersData(userAnswerssData, 'INSIGHTS')}
			/>

			<div className='ta-result-details_website-links-container'>
				<div className='ta-result-details-header_title'>Take a deep knowledge dive into support</div>
				<div className='ta-result-details_website-link-container'>
					<a className='ta-result-details_website-link-card' href={BUYERS_GUIDE_LINK}>
						<div className='ta-result-details_website-link-img'>
							<img
								src={BUYERS_GUIDE_IMG}
								alt=''
							/>
						</div>
						<div className='ta-result-details_website-link-text'>
							A buyer’s guide to customer support platforms in
							2021
						</div>
						<div className='ta-result-details_website-link-cta'>
							<div>Learn more {'>>'}</div>
							<img
								src={LEARN_MORE_ICON}
								alt=''
							/>
						</div>
					</a>

					<a className='ta-result-details_website-link-card' href={SUPPORT_LEADERS_CHALLENGES_LINK}>
						<div className='ta-result-details_website-link-img'>
							<img
								src={SUPPORT_LEADERS_CHALLENGES_IMG}
								alt=''
							/>
						</div>
						<div className='ta-result-details_website-link-text'>
							Support leaders challenges in 2020
						</div>
						<div className='ta-result-details_website-link-cta'>
							<div>Download now {'>>'}</div>
							<img
								src={DOWNLOAD_NOW_ICON}
								alt=''
							/>
						</div>
					</a>

					<a className='ta-result-details_website-link-card' href={CX_LIBRARY_LINK}>
						<div className='ta-result-details_website-link-img'>
							<img
								src={CX_LIBRARY_IMG}
								alt=''
							/>
						</div>
						<div className='ta-result-details_website-link-text'>CX library</div>
						<div className='ta-result-details_website-link-cta'>
							<div>Learn more {'>>'}</div>
							<img
								src={LEARN_MORE_ICON}
								alt=''
							/>
						</div>
					</a>
				</div>
			</div>
		</div>
	);
};
